const urlSearchObj = function () {
  var url = "" + (arguments[0] || window.location.search);
  // var url = "" + arguments[0];
  var _url;
  // _url = decodeURI(url.split('?')[1])
  _url = url.split("?") && url.split("?")[1];
  var _s = _url && _url.split("&");
  var d = {};
  if (_s) {
    for (var i = 0; i < _s.length; i++) {
      var _v = _s[i].split("=");
      if (_v[0] === "id" && _v[1].indexOf("!") !== -1) {
        d[_v[0]] = _v[1].slice(0, -1);
      } else {
        d[_v[0]] = _v[1];
      }
    }
  }
  return d;
};

const dataFunction = () => {
  var date = new Date();
  var year = date.getFullYear();
  /* 在日期格式中，月份是从0开始的，因此要加0
   * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
   * */
  var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
  var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
  var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
  var minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
  var seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
  // 拼接
  // return year+"-"+month+"-"+day+" "+hours+":"+minutes+":"+seconds;
  return `${hours}00`;
};

// 获取今天 明天 昨天的日期
const getDateTime = (type) => {
  // 获取当前日期
  let timestamp = Date.parse(new Date());
  let date = new Date(timestamp);
  if (type == 'tomorrow') { // 明天
    date.setDate(date.getDate() + 1);

  } else if (type == 'today') { // 今天
    date.setDate(date.getDate());
  } else if (type == 'yestoday') {
    date.setDate(date.getDate() - 1);
  }
  //获取年份 ?
  var Y = date.getFullYear();
  //获取月份 ?
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
  //获取当日日期?
  var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
  let todayDate = Y + '-' + M + '-' + D;
  // todayDate = todayDate.replace(/-/g, "")
  return todayDate
};

//日期加减法  date参数为计算开始的日期，days为需要加的天数   
//格式:addDate('2017-1-11',20) 
const addDate = (date, days) => {
  var d = new Date(date);
  d.setDate(d.getDate() + days);
  var m = d.getMonth() + 1;
  m < 10 ? m = '0' + m : m
  var dd = d.getDate()
  dd < 10 ? dd = '0' + dd : dd
  return d.getFullYear() + '-' + m + '-' + dd;
}

const formatArr = (arr) => {
  arr.forEach(item => {
    if (item.time) {
      item = parseInt(item.time)
    } else {
      item = parseInt(item)
    }

  })
  var len = arr.length;
  for (var i = 0; i < len - 1; i++) {
    for (var j = 0; j < len - 1 - i; j++) {
      // 相邻元素两两对比，元素交换，大的元素交换到后面
      if (arr[j].time) {
        if (arr[j].time > arr[j + 1].time) {
          var temp = arr[j];
          arr[j] = arr[j + 1];
          arr[j + 1] = temp;
        }
      } else {
        if (arr[j] > arr[j + 1]) {
          var temp = arr[j];
          arr[j] = arr[j + 1];
          arr[j + 1] = temp;
        }
      }

    }
  }
  return arr;
}

const isEmpty = function (v) {
  switch (typeof v) {
    case 'undefined':
      return true
    case 'string':
      if (v.replace(/(^[ \t\n\r]*)|([ \t\n\r]*$)/g, '').length == 0) return true
      break
    case 'boolean':
      if (!v) return true
      break
    case 'number':
      if (v === 0 || isNaN(v)) return true
      break
    case 'object':
      if (v === null || v.length === 0) return true
      for (var i in v) {
        return false
      }
      return true
  }
  return false
}


/**
 * 设置 localStoryage
 * @param key 键
 * @param value 值
 * @param expire 过期时间(秒) 缓存最大时间请勿超过 forceTime 否则每次都会清空数据 (未设置请忽略)
 * @return bool true
 */
function cacheSet(key, value = '', expire = 0) {
  // 当前时间戳
  var nowTime = Math.ceil(Date.now() / 1000);
  // 设置数据
  localStorage.setItem(key, value)
  // 判断是否有过期时间
  if (expire > 0) {
    // 设置过期时间
    // localStorage.setItem(key + '_expire', (nowTime + parseInt(expire)))
    localStorage.setItem(key + '_expire', (parseInt(expire)))
  }
  else {
    // 设置过期时间
    localStorage.setItem(key + '_expire', 0)
  }
  return true;
}


/**
 * 读取 localStoryage
 * @param key
 * @return bool|originData false|originData
 */
function cacheGet(key) {
  // 当前时间戳
  var nowTime = Math.ceil(Date.now() / 1000);
  // 获取键时间戳
  var rawCacheDataExpire = localStorage.getItem(key + '_expire');
  var cacheDataExpire = parseInt(rawCacheDataExpire);

  // 判断用户是否删除了过期时间 判断是否设置了过期时间 判断是否超过过期时间 判断当前计算机时间与设置的过期时间差距是否过大
  if ((rawCacheDataExpire === null) || (cacheDataExpire > 0) && (nowTime > cacheDataExpire)) {
    // 删除过期key
    localStorage.removeItem(key)
    // 删除过期时间
    localStorage.removeItem(key + '_expire')
    return false;
  }

  // 获取数据
  let cacheData = localStorage.getItem(key)

  if (cacheData === null || cacheData === false) {
    return false;
  }
  // 返回数据
  return cacheData;

}

function compare(property) {
  return function (a, b) {
    var value1 = a[property];
    var value2 = b[property];
    return value2 - value1;//升序,降序为value2 - value1
  }
}

function formatDate(date) {
  let arr = date.toString().split('')
  let year = `${arr[0]}${arr[1]}${arr[2]}${arr[3]}年`
  let month = `${arr[4]}${arr[5]}月`
  let day = `${arr[6]}${arr[7]}日`
  return `${year}${month}${day}`
}

function formatStartTime(time) {
  let str = ''
  if (time < 100) {
    str = '00' + str
  } else if (time < 1000) {
    str = '0' + str
  }
  return str
}

function formatEndTime(time) {
  let str = ''
  if (time < 100) {
    str = '00' + str
  } else if (time < 1000) {
    str = '0' + str
  }
  return str
}

function formatStartTimeTips(value) {
  let v = parseInt(value);
  let m = parseInt(value / 100);
  m < 10 ? (m = "0" + m) : m;
  let s = v % 100;
  s < 10 ? (s = "0" + s) : s;
  return `${m}:${s}`;
}

function formatEndTimeTips(value) {
  let v = parseInt(value) + 15;
  let m = parseInt(v / 100);
  let mm = v % 100
  if (mm == 60) {
    mm = 0
    m = m + 1
  }
  m < 10 ? (m = "0" + m) : m;
  mm < 10 ? (mm = "0" + mm) : mm;
  return `${m}:${mm}`;
}

function allTime(start, end) {
  let endTMP = parseInt(end) + 15
  let hs = parseInt(+start / 100)
  let he = parseInt(+end / 100)
  let hl = he - hs
  let ms = +start % 100
  let me = +endTMP % 100
  let ml = me - ms
  return hl * 60 + ml
}

export {
  urlSearchObj,
  getDateTime,
  addDate,
  formatArr,
  isEmpty,
  cacheSet,
  cacheGet,
  compare,
  formatDate,
  formatStartTime,
  formatEndTime,
  formatStartTimeTips,
  formatEndTimeTips,
  allTime,
  dataFunction
};
